import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import {
  DeleteConfirmationData,
  DeleteconfirmationdialogComponent,
} from '../../components/deleteconfirmationdialog/deleteconfirmationdialog.component';

export function openDeleteConfirmationDialog(
  dialog: MatDialog,
  title: string,
  message: string
): MatDialogRef<DeleteconfirmationdialogComponent, boolean> {
  const data: DeleteConfirmationData = { title, message };

  return dialog.open<DeleteconfirmationdialogComponent, DeleteConfirmationData, boolean>(
    DeleteconfirmationdialogComponent,
    {
      width: '400px',
      data,
      autoFocus: false,
      restoreFocus: false,
    }
  );
}
